import { render } from "./Seo.vue?vue&type=template&id=935251dc"
import script from "./Seo.vue?vue&type=script&lang=js"
export * from "./Seo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__